<template>
  <path
    d="M31.625 10H8.875C8.39102 10 8 10.391 8 10.875V28.375C8 28.859 8.39102 29.25 8.875 29.25H31.625C32.109 29.25 32.5 28.859 32.5 28.375V10.875C32.5 10.391 32.109 10 31.625 10ZM9.96875 11.9688H30.5312V15.25H9.96875V11.9688ZM30.5312 27.2812H9.96875V17.6562H30.5312V27.2812ZM24.0508 25.5312H28.5625C28.6828 25.5312 28.7812 25.4328 28.7812 25.3125V23.3438C28.7812 23.2234 28.6828 23.125 28.5625 23.125H24.0508C23.9305 23.125 23.832 23.2234 23.832 23.3438V25.3125C23.832 25.4328 23.9305 25.5312 24.0508 25.5312Z"
  />
</template>
